import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {PolicyArticle} from './policy-article/PolicyArticle';

export function AccessibilityStatement() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const {t} = useTranslation();

    useEffect(() => {
        document.title = t('route_name.accessibility');
        return () => {
            document.title = t('route_name.home');
        };
    }, [t]);

    return (
        <>
            <PolicyArticle
                heading={t('policy.accessibility_statement_heading')}
                article={t('policy.accessibility_statement', {returnObjects: true})}
            />
        </>
    );
}
